import { Pipe, PipeTransform } from '@angular/core';
import { convertToLocalDate } from '../../core';


/**
 * Pipe to convert Date in local format string.
 */
@Pipe({
	name: 'convertDate'
})
export class ConvertDatePipe implements PipeTransform {

	transform(date: Date | null, UTCMode = true): string | null {
		return date ? convertToLocalDate(date, UTCMode) : null;
	}

}
